"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tokens_1 = require("../../tokens");
exports.stringLiteral = ({ ast }) => {
    const image = ast.children.StringLiteral[0].image.slice(1).slice(0, -1);
    return {
        name: tokens_1.LiteralTokens.StringLiteral,
        image,
    };
};
